module.exports = __webpack_public_path__ + "static/media/sadness-face.f341e516.png";